import { render, staticRenderFns } from "./ExpirationAccountSubList.vue?vue&type=template&id=28089566"
import script from "./ExpirationAccountSubList.vue?vue&type=script&lang=js"
export * from "./ExpirationAccountSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports